<template>
  <div v-if="isVisible" class="modal-overlay">
    <div class="modal-content">
      <h3>Seleccione el Rango de Fechas</h3>

      <div class="form-group">
        <label for="desde">Desde:</label>
        <input type="date" v-model="desde" id="desde" />
      </div>

      <div class="form-group">
        <label for="hasta">Hasta:</label>
        <input type="date" v-model="hasta" id="hasta" />
      </div>

      <div class="form-group">
        <label for="regional">Regional:</label>
        <select v-model="regionalSeleccionada" id="regional">
          <option v-for="r in regionales" :key="r.id" :value="r.id">
            {{ r.nombre }}
          </option>
        </select>
      </div>

      <div class="modal-actions">
        <button @click="emitirReporte">Generar</button>
        <button @click="cerrarModal">Cancelar</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ReporteMensualModal',
  props: {
    visible: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      isVisible: this.visible,
      desde: '',
      hasta: '',
      regionalSeleccionada: null,
      regionales: []
    };
  },
  watch: {
    visible(val) {
      this.isVisible = val;
    }
  },
  methods: {
    cerrarModal() {
      this.$emit('close');
    },
    emitirReporte() {
      if (!this.desde || !this.hasta || !this.regionalSeleccionada) {
        alert("Debe completar todos los campos.");
        return;
      }
      this.$emit('generar', {
        desde: this.desde,
        hasta: this.hasta,
        regional_id: this.regionalSeleccionada
      });
      this.cerrarModal();
    },
    async cargarRegionales() {
      const token = localStorage.getItem("authToken");
      try {
        const res = await fetch('https://alexpruebas.tamep.bo/kqlurhnh_conciliacion/regional/listar_regionales.php', {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });
        this.regionales = await res.json();
      } catch (e) {
        console.error('Error al cargar regionales:', e);// eslint-disable-line no-console
      }
    }
  },
  mounted() {
    this.cargarRegionales();
  }
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-content {
  background: white;
  padding: 20px;
  border-radius: 8px;
  width: 350px;
  max-width: 90%;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
}

.form-group {
  margin-bottom: 15px;
}

.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}
</style>
